import styled from "styled-components";

export const InputWrapper = styled.fieldset`
  position: relative;
  border: none;
  padding: 0;
  margin: 0;
`;
